import { getRecordsForCompositeTargetCollection } from '../../reducers/standard_reducer_utils';
import { valueCompareWithoutType } from '../../utils/DataAccessUtils';
import { WO_STEP_NAMES } from '../../utils/DataConstants';

export const AREA_LEVELS = {
	TOP_LEVEL: 'areasTopLevel',
	NEXT_LEVEL: 'areasNextLevel',
	NEXT_BRANCH: 'areasNextBranch',
};

interface AREA_FIELDS {
	currentStep: string;
	nextStep: string;
	prevLevelId: string;
	currentLevelId: string;
	nextLevelAvailable: string;
}

export const getAreaStepStateVariables = (fieldName: string): AREA_FIELDS => {
	switch (fieldName) {
		case AREA_LEVELS.NEXT_LEVEL:
			return {
				currentStep: WO_STEP_NAMES.AREA_NEXT_LEVEL,
				nextStep: WO_STEP_NAMES.AREA_NEXT_BRANCH,
				currentLevelId: 'areaLevel2Id',
				prevLevelId: 'areaLevel1Id',
				nextLevelAvailable: 'area3Available',
			};
		case AREA_LEVELS.NEXT_BRANCH:
			return {
				currentStep: WO_STEP_NAMES.AREA_NEXT_BRANCH,
				nextStep: WO_STEP_NAMES.AREA_NEXT_LEVEL,
				currentLevelId: 'areaLevel3Id',
				prevLevelId: 'areaLevel2Id',
				nextLevelAvailable: 'area4Available',
			};
		default:
			return {
				currentStep: WO_STEP_NAMES.AREA_TOP_LEVEL,
				nextStep: WO_STEP_NAMES.AREA_NEXT_LEVEL,
				currentLevelId: 'areaLevel1Id',
				prevLevelId: '',
				nextLevelAvailable: 'area2Available',
			};
	}
};

export interface AREA_STEP_PROPS {
	goNext: any;
	setState: any;
	getCurrentState: any;
	areas: any;
	TC_NAME: string;
	fetchArea: any;
	changeId: any;
}

const getAreaObject = (args: AREA_STEP_PROPS) => (areaId) => {
	const { areas, TC_NAME, fetchArea } = args;
	const records = getRecordsForCompositeTargetCollection(areas, TC_NAME);

	const area = records.find(({ id }) => valueCompareWithoutType(id, areaId));
	if (area) {
		return Promise.resolve(area);
	}

	return fetchArea(areaId);
};

export const handleAreaChange =
	(args: AREA_STEP_PROPS) =>
	(fieldName, areaId, ignoreTroubleshooting = false) => {
		const { changeId, setState, goNext } = args;
		const stateVariables = getAreaStepStateVariables(fieldName);
		changeId(stateVariables.currentLevelId, areaId);
		getAreaObject(args)(areaId).then((area) => {
			setState({ area: area });
			if (area.hasChildren) {
				const updateStates = {
					[stateVariables.currentLevelId]: areaId,
					[stateVariables.nextLevelAvailable]: true,
					areaPriorLevelId: areaId,
					areaPriorLevel: area.name,
				};
				setState(updateStates, () => {
					goNext(
						[],
						stateVariables.nextStep,
						stateVariables.currentStep,
						ignoreTroubleshooting,
						false,
						updateStates
					);
				});
			} else {
				setState(
					{
						[stateVariables.nextLevelAvailable]: false,
						areaPriorLevelId: undefined,
						areaPriorLevel: undefined,
					},
					() => {
						let nextStep = WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL;
						if (areaId == 6497) {
							nextStep = WO_STEP_NAMES.ASSET_CHECK;
						}
						goNext([], nextStep, stateVariables.currentStep, ignoreTroubleshooting);
					}
				);
			}
		});
	};
